var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    !_vm.showFilters && !_vm.isDesktop
      ? _c("div", { staticClass: "c-filter__show-filters-banner" }, [
          _c(
            "div",
            { staticClass: "c-mobile-nav__search c-contact-filter__search" },
            [
              _c(
                "label",
                {
                  staticClass: "t-visually-hidden",
                  attrs: { for: "search-input" },
                },
                [_vm._v("Sök")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchValue,
                    expression: "searchValue",
                  },
                ],
                attrs: {
                  type: "text",
                  name: "q",
                  id: "search-input mobile-search-bar input",
                  placeholder: this.translate.searchonnameorroleorcity,
                },
                domProps: { value: _vm.searchValue },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchContacts.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchValue = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.searchValue
                ? _c(
                    "button",
                    {
                      staticClass: "clear-button",
                      on: { click: _vm.clearSearch },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "c-icon c-icon--xxs c-main-nav__close-icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("svg", [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-close" },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "container-search-button" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "c-main-nav__search-button c-contact-filter__button",
                    attrs: { type: "submit" },
                    on: { click: _vm.searchContacts },
                  },
                  [
                    _c("span", { staticClass: "t-visually-hidden" }, [
                      _vm._v("Sök"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-icon c-icon--xs c-main-nav__search-icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c("svg", [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-search" },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "filter-results-container" }, [
            _c(
              "button",
              {
                staticClass: "filter-button",
                on: { click: _vm.showMobileFilters },
              },
              [
                _c("div", { staticClass: "container-filter-button" }, [
                  _c("span", { staticClass: "filter-text" }, [
                    _vm._v(_vm._s(this.translate.filter)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "c-icon c-icon--xs slider-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("svg", [
                        _c("use", { attrs: { "xlink:href": "#icon-sliders" } }),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showFilters || _vm.isDesktop
      ? _c("div", { staticClass: "c-filter c-contact-filter" }, [
          _c(
            "div",
            { staticClass: "c-filter__wrapper c-contact-filter__wrapper" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "c-filter__content-wrapper c-contact-filter__content-wrapper o-width-limiter",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "c-filter__dropdown-wrapper c-contact-filter__dropdown-wrapper",
                    },
                    [
                      _vm._l(_vm.filters, function (filter) {
                        return _c(
                          "v-filter-dropdown",
                          {
                            key: filter.id,
                            attrs: {
                              id: filter.id,
                              "button-text": _vm.getSelectedLabel(filter),
                              "dropdown-open": _vm.activeFilter === filter.id,
                              translate: _vm.translate,
                              label: filter.label,
                            },
                            on: {
                              "toggle-dropdown": function ($event) {
                                return _vm.toggleDropdown(filter.id)
                              },
                            },
                          },
                          [
                            _vm.isDesktop && _vm.activeFilter === filter.id
                              ? _c(
                                  "ul",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.handleClickOutside,
                                        expression: "handleClickOutside",
                                      },
                                    ],
                                    staticClass: "c-filter-dropdown__list",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-filter__city-wrapper" },
                                      _vm._l(filter.options, function (option) {
                                        return _c(
                                          "li",
                                          {
                                            key: option.value,
                                            staticClass: "c-filter__city",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSelection(
                                                  filter,
                                                  option
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "has-sub-options":
                                                    option.options &&
                                                    option.options.length > 0,
                                                },
                                              },
                                              [_vm._v(_vm._s(option.text))]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              option.options || [],
                                              function (sub) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: sub.value,
                                                    staticClass:
                                                      "c-filter__city ml-4",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.handleSelection(
                                                          filter,
                                                          sub
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(sub.text) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isDesktop && _vm.activeFilter === filter.id
                              ? _c(
                                  "ul",
                                  { staticClass: "c-filter-dropdown__list" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-filter__city-wrapper" },
                                      _vm._l(filter.options, function (option) {
                                        return _c(
                                          "li",
                                          {
                                            key: option.value,
                                            staticClass: "c-filter__city",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSelection(
                                                  filter,
                                                  option
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "has-sub-options":
                                                    option.options &&
                                                    option.options.length > 0,
                                                },
                                              },
                                              [_vm._v(_vm._s(option.text))]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              option.options || [],
                                              function (sub) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: sub.value,
                                                    staticClass:
                                                      "c-filter__city ml-4",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.handleSelection(
                                                          filter,
                                                          sub
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(sub.text) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-main-nav__search c-contact-filter__search",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "t-visually-hidden",
                              attrs: { for: "search-input" },
                            },
                            [_vm._v("Sök")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchValue,
                                expression: "searchValue",
                              },
                            ],
                            attrs: {
                              type: "text",
                              name: "q",
                              id: "search-input",
                              placeholder:
                                this.translate.searchonnameorroleorcity,
                            },
                            domProps: { value: _vm.searchValue },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchContacts.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.searchValue = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.searchValue
                            ? _c(
                                "button",
                                {
                                  staticClass: "clear-button",
                                  on: { click: _vm.clearSearch },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "c-icon c-icon--xxs c-main-nav__close-icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("svg", [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-close",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "container-search-button" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "c-main-nav__search-button c-contact-filter__button",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.searchContacts },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "t-visually-hidden" },
                                    [_vm._v("Sök")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "c-icon c-icon--xs c-main-nav__search-icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("svg", [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-search",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-filter__button-container" }, [
                    _c(
                      "button",
                      {
                        staticClass: "c-filter__button-cancel",
                        on: { click: _vm.closeMobileFilter },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(this.translate.cancel) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }